<template>
    <div class="principal">
        <NavBar :usarAberto="false" :usarHistorico="false" :usarVoltar="true" :usarDeslogar="false" :usarGerenciar="false"
            :usarRelatorio="false" :usarRelatorioEstrela="false" :usarFiltros="true" :usarFiltroSetor="true"
            :usarFiltroTpChamado="true" :usarFiltroPosicao="false" :usarFiltroDatas="true"
            :nomeTela="'Quantidade de Atendimento para cada Estrela'" :usarTrocaVisualizacao="true" :card="false"
            :tabela="true" :grafico="true" :visualizacaoPadrao="'Grafico'" @filtrar="filtrar()"
            :formatarDataInicioMes="formatarDataInicioMes" />
        <div class="mainDiv">
            <table class="table table-striped table-bordered" v-show="this.tabela === 'Tabela'">
                <thead>
                    <tr>
                        <th class="ps-4">Estrelas</th>
                        <th class="ps-3">Porcentagem</th>
                        <th class="ps-3">Confirmados</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(d, index) in this.dadosRelatorioTabela" :key="index">
                        <!-- <td> {{ d }} </td> -->
                        <td class="col-sm-6 col-md-6">
                            <star-rating v-model:rating="d.estrelas" :read-only="true" :show-rating="false"
                                :border-width="5">
                            </star-rating>
                        </td>
                        <td class="pt-4 ps-4 col-sm-2 col-md-2"> {{ d['porcentagem'] }}% </td>
                        <td class="pt-4 ps-4 col-sm-2 col-md-2"> {{ d.qtdeConfirmados }} </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="d-flex justify-content-center" v-show="this.tabela === 'Grafico'">
            <canvas id="QtdeAtendParaEstrela" class="graficoRelatorio"></canvas>
        </div>

    </div>
    <ModalEditar :mostrar="this.mostrarModal" :modalLargo="true" :tamanhoModal="60">
        <template v-slot:header>
            <h2>Motivos</h2>
        </template>
        <template v-slot:corpo>
            <table class="table table-striped table-bordered">
                <thead>
                    <tr>
                        <th class="col-sm-2 col-md-2">Código do Leito</th>
                        <th class="col-sm-1 col-md-1">Chamado</th>
                        <th class="col-sm-1 col-md-1">Data</th>
                        <th class="col-sm-8 col-md-8">Motivo</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(d, index) in this.dadoModal" :key="index">
                        <td class="col-sm-2 col-md-2"> {{ d.codigoLeito }} </td>
                        <td class="col-sm-1 col-md-1"> {{ d.chamadoDescricao }} </td>
                        <td class="col-sm-1 col-md-1"> {{ retornaDataFormatada(d.data) }} </td>
                        <td class="col-sm-8 col-md-8" v-show="d.motivo === null"> Não Justificado </td>
                        <td class="col-sm-8 col-md-8" v-show="d.motivo !== null"> {{ d.motivo }} </td>
                    </tr>
                </tbody>
            </table>
        </template>
        <template v-slot:rodape>
            <button class="btn btn-secondary" @click="fecharModal()">Fechar</button>
        </template>
    </ModalEditar>
    <ModalEditar :mostrar="existeErro" :tamanhoModal="30">
        <template v-slot:header>
            {{ this.titulo }}
        </template>
        <template v-slot:corpo>
            {{ this.textoErro }}
        </template>
        <template v-slot:rodape>
            <button @click="desativarModal()" class="btn btn-primary">Entendi</button>
        </template>
    </ModalEditar>
</template>

<script>
import api from '@/api/api';
import _versao from '@/../package.json';
import { Chart, CategoryScale, BarController, BarElement, Title, LineController, LinearScale } from 'chart.js';
import store from "@/store/store";
import NavBar from '@/components/NavBar.vue';
import moment from 'moment';
import ModalEditar from '@/components/ModalEditar.vue';
import StarRating from 'vue-star-rating';

export default {
    name: "relatoriO",
    props: ['formatarDataInicioMes'],
    mounted() {
        Chart.register(LinearScale, LineController, CategoryScale, BarElement, BarController, Title);
        this.filtrar(0, 0, 0, "FE", this.formatarDataInicioMes(new Date()), new Date(), this.tabela);
    },
    data() {
        return {
            versao: _versao.version,
            dados: [],
            dadosRelatorioTabela: [],
            grafico: null,
            filtroTpChamado: Boolean(),
            dataInicial: new Date(),
            mostrarModal: false,
            dadoModal: [],
            tabela: "Grafico",
            teste: 5,
            titulo: String(),
            textoErro: String(),
            existeErro: Boolean()
        };
    },
    methods: {
        async construirTabela(pValorFiltroSetor, pValorFiltroTPChamado, pDataInicial, pDataFinal) {
            let sql = `SELECT C.AVALIACAO, count(*)
                        FROM CHAMADO C
                        JOIN TIPO_CHAMADO T ON T.ID = C.ID_TIPO_CHAMADO
                        JOIN LEITO L ON L.ID = C.ID_LEITO
                        JOIN QUARTO Q ON Q.ID = L.ID_QUARTO
                        JOIN SETOR S ON S.ID = Q.ID_SETOR
                        WHERE
                        C.POSICAO = 'FE' `;
            if (this.retornaData(pDataInicial) > this.retornaData(pDataFinal)) {
                this.titulo = "Aviso";
                this.textoErro = "A Data Inicial não pode ser maior que a Data Final";
                this.existeErro = true;
            } else {
                if (pValorFiltroSetor > 0) {
                    sql += `AND S.ID=${pValorFiltroSetor} `;
                }
                if (pValorFiltroTPChamado > 0) {
                    sql += `AND C.ID_TIPO_CHAMADO=${pValorFiltroTPChamado} `;
                }
                let auxDataInicial = this.retornaDataSql(pDataInicial);
                let auxDataFinal = this.retornaDataSql(pDataFinal);
                sql += ` AND C.DATA between '${auxDataInicial}' and '${auxDataFinal}'
                         group by 1 
                `;
                await api.listarSql(sql)
                    .then(resp => {
                        this.dadosRelatorioTabela = [];
                        let total = 0;
                        resp.forEach((r) => {
                            let aux = {};
                            aux['estrelas'] = r[0];
                            aux['qtdeConfirmados'] = r[1];
                            total += r[1];
                            this.dadosRelatorioTabela.push(aux);
                        });
                        this.dadosRelatorioTabela.forEach(d => {
                            let aux = parseFloat((d.qtdeConfirmados / total) * 100).toFixed(2);
                            d['porcentagem'] = aux;
                        });
                    });
            }
        },

        async construirGrafico(auxDataInicial, auxDataFinal) {
            const graficoQtdeAtendParaEstrela = document.querySelector("#QtdeAtendParaEstrela").getContext("2d");
            if (this.grafico) {
                this.grafico.destroy();
            }

            let estrelas = [];
            let confirmados = [];
            let porcentagens = [];
            let bgColor = 'rgba(255, 99, 132, 0.2)';

            this.dadosRelatorioTabela.forEach((d) => {
                estrelas.push(d.estrelas);
                porcentagens.push(d.porcentagem);
                confirmados.push(d.qtdeConfirmados + " Confirmados");
                if (this.filtroTpChamado) {
                    bgColor = d.cor;
                }
            });

            const hoverValue = {
                id: 'hoverValue',
                afterDatasetsDraw(chart) {
                    const { ctx, data, options } = chart;
                    chart.getActiveElements().forEach((active) => {
                        const value = `${data.datasets[active.datasetIndex].data[active.index]}★ - ${data.datasets[active.datasetIndex].porcentagem[active.index]}%`;// em ${data.labels[active.index]} Atendimento(s)`;
                        const fontSize = options.hoverRadius;
                        ctx.save();
                        ctx.textAlign = 'center';
                        ctx.font = `bold ${fontSize}px sans-serif`;
                        ctx.lineDashOffset = 10;
                        ctx.fillText(value, active.element.x, active.element.y);
                        ctx.restore();
                    });
                }
            };

            estrelas.push(5);
            estrelas.push(0);

            this.grafico = new Chart(graficoQtdeAtendParaEstrela, {
                type: "bar",
                data: {
                    labels: confirmados,
                    datasets: [{
                        label: 'Quantidade de Atendimentos para cada Estrela',
                        data: estrelas,
                        porcentagem: porcentagens,
                        maxBarThickness: 75,
                        backgroundColor: [bgColor],
                        borderColor: ['rgb(255, 99, 132)'],
                        borderWidth: 1,
                    }]
                },
                options: {
                    hoverRadius: 20,
                    plugins: {
                        title: {
                            display: true,
                            text: 'Quantidade de Atendimentos para cada Estrela',
                            padding: {
                                top: 10,
                                bottom: 30
                            },
                            font: {
                                size: 20
                            }
                        }
                    },
                    onClick: async (e, active) => {
                        let numeroEstrelas;
                        let sql = "";
                        e.chart.data.datasets.forEach((d, index) => {
                            numeroEstrelas = d.data[active[index].index];
                        });

                        sql += `
                                SELECT 
                                C.AVALIACAOMOTIVO, C.DATA, T.DESCRICAO, L.CODIGO_LEITO
                                FROM CHAMADO C
                                JOIN TIPO_CHAMADO T ON T.ID = C.ID_TIPO_CHAMADO
                                JOIN LEITO L ON L.ID = C.ID_LEITO
                                WHERE
                                C.AVALIACAO = ${numeroEstrelas}
                                AND C.DATA BETWEEN '${auxDataInicial}' and '${auxDataFinal}'
                                ORDER BY C.DATA DESC`;

                        await api.listarSql(sql)
                            .then(resp => {
                                resp.forEach(r => {
                                    this.dadoModal.push({
                                        'motivo': r[0],
                                        'data': r[1],
                                        'chamadoDescricao': r[2],
                                        'codigoLeito': r[3]
                                    });
                                });
                            });
                        this.mostrarModal = true;
                    }
                },
                plugins: [hoverValue]
            });
        },

        retornaData(pData) {
            return new Date(pData);
        },

        retornaDataFormatada(pData) {
            return moment(pData).format("DD/MM/YYYY");
        },

        retornaDataSql(pData) {
            return moment(pData).format("DD.MM.YYYY");
        },

        async filtrar(aux, pValorFiltroSetor, pValorFiltroTPChamado, pValorFiltroPosicao, pDataInicial, pDataFinal, pVisualizacao) {
            this.tabela = pVisualizacao;
            if (this.grafico) {
                this.grafico.destroy();
            }
            await this.construirTabela(pValorFiltroSetor, pValorFiltroTPChamado, pDataInicial, pDataFinal);
            if (pVisualizacao === "Grafico") {
                this.construirGrafico(this.retornaDataSql(pDataInicial), this.retornaDataSql(pDataFinal));
            }
        },

        fecharModal() {
            this.dadoModal = [];
            this.mostrarModal = false;
        },

        deslogar() {
            sessionStorage.removeItem("TokenReguaPainel");
            this.$router.back();
        },

        desativarModal() {
            this.existeErro = false;
        },
    },
    computed: {
        setores() {
            return store.state.setores;
        },
        config() {
            return store.state.config;
        },
        tipoChamado() {
            return store.state.tipoChamado;
        },
    },
    components: {
        NavBar,
        ModalEditar,
        StarRating
    }
};
</script>

<style scoped></style>